<!-- eslint-disable prettier/prettier -->
<!-- the button tag placement is intentional to preserve the whitespace between them -->
<template>
  <div class="stlc__pagination__outline">
    <span class="page-number">{{ headerText }}</span>
    <div>
      <button
        type="button"
        class="stlc__pagination"
        :disabled="currentPage === 1"
        :class="{ stlc__pagination__disable: currentPage === 1 }"
        @click="$emit('page-change', currentPage - 1, 'prev')"
      >
        {{ previousButtonText }}
      </button> <button
        type="button"
        class="stlc__pagination"
        :disabled="currentPage >= lastPage"
        :class="{ stlc__pagination__disable: currentPage >= lastPage }"
        @click="$emit('page-change', currentPage + 1, 'next')"
      >
        {{ nextButtonText }}
      </button> 
    </div>
  </div>
</template>
<!-- eslint-enable prettier/prettier -->

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
export default {
  name: 'rfp-stlc-pagination',
  props: {
    prefixContent: {
      type: String,
      default: 'Page',
    },
    middleContent: {
      type: String,
      default: 'of',
    },
    previousButtonText: {
      type: String,
      default: 'Previous',
    },
    nextButtonText: {
      type: String,
      default: 'Next',
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    lastPage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    headerText() {
      return `${this.prefixContent || 'Page'} ${this.currentPage} ${this.middleContent || 'of'} ${
        this.lastPage
      }`;
    },
  },
};
</script>
